import { render, staticRenderFns } from "./OptionTypes.vue?vue&type=template&id=21a36cd1&"
import script from "./OptionTypes.vue?vue&type=script&lang=js&"
export * from "./OptionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports